import React from 'react'
import { useNotify, Spinner } from 'app/theme'
import { useMutation } from 'jsonapi-react'
import { Input, Submit } from 'app/theme/forms'

export default function ChangePassword({ session }) {
  const notify = useNotify()

  const [mutate, {
    data,
    setData,
    errors,
  }] = useMutation(['users', session.user.id], {
    initialData: { password: '', password_confirmation: '' }
  })

  const onSubmit = () => {
    mutate(data).then(res => {
      if (res.data) {
        notify.show({
          theme: 'success',
          title: 'Success',
          message: 'Password was updated!',
        })
      } else if (res.errors) {
        notify.show({
          theme: 'error',
          title: 'Error',
          message: 'Please correct the invalid fields.',
        })
      } else {
        notify.show({
          theme: 'error',
          title: 'Error',
          message: 'Unable to update password.',
        })
      }
    })
  }

  return (
    <div className="bg-white rounded shadow p-5 md:p-8">
      <h1 className="text-2xl font-platform text-navy mb-5">
        Change Password
      </h1>
      <div className="grid gap-6">
        <Input
          type="password"
          label="Password"
          value={data.password}
          error={errors?.password?.[0]?.detail}
          onChange={password => setData(data => ({ ...data, password }))}
        />
        <Input
          type="password"
          label="Confirm Password"
          value={data.password_confirmation}
          error={errors?.password_confirmation?.[0]?.detail}
          onChange={password_confirmation => setData(data => ({ ...data, password_confirmation }))}
        />
        <div className="mt-3 pt-8 border-t border-gray-200 flex justify-center">
          <button
            type="submit"
            children="Save Changes"
            className="btn btn-blue px-20 py-2 rounded-sm text-lg"
            onClick={onSubmit}
          />
        </div>
      </div>
    </div>
  )
}
